// ---------------------------------------------------------------------------
// Prezio Onboard Widget — Button
// ---------------------------------------------------------------------------
// Primary action button. Variants: 'primary', 'secondary'.
// Min-height 48px for touch targets. Inline spinner for loading state.
// ---------------------------------------------------------------------------

import { Spinner } from '@/components/ui/Spinner';
import { cn } from '@/utils/cn';
import styles from './Button.module.css';

interface ButtonProps {
  label: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  isLoading?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit';
  fullWidth?: boolean;
}

export function Button({
  label,
  onClick,
  variant = 'primary',
  isLoading = false,
  disabled = false,
  type = 'button',
  fullWidth = false,
}: ButtonProps) {
  return (
    <button
      className={cn(
        styles['button'],
        styles[variant],
        fullWidth && styles['fullWidth'],
        isLoading && styles['loading'],
      )}
      onClick={onClick}
      disabled={disabled || isLoading}
      type={type}
      aria-busy={isLoading || undefined}
    >
      {isLoading && (
        <span className={styles['spinnerWrapper']}>
          <Spinner size="sm" />
        </span>
      )}
      <span className={isLoading ? styles['labelHidden'] : undefined}>{label}</span>
    </button>
  );
}
